import React from 'react';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import classes from './Footer.module.scss';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const socialLinks = [
    { name: 'GitHub', url: 'https://github.com/arsanyu', icon: <FaGithub /> },
    { name: 'LinkedIn', url: 'https://linkedin.com/in/arsanyu', icon: <FaLinkedin /> },
    { name: 'Twitter', url: 'https://twitter.com/arsanyu', icon: <FaTwitter /> },
  ];

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/#services' },
    { name: 'Portfolio', href: '/#portfolio' },
    { name: 'Contact', href: '/#contact' },
  ];

  const handleQuickLinkClick = (e, link) => {
    e.preventDefault();
    if (link.href === '/') {
      navigate('/');
    } else if (link.href.startsWith('/#')) {
      // If we're already on home page, scroll to section
      if (location.pathname === '/') {
        const sectionId = link.href.substring(2); // Remove '/#'
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Navigate to home page with section
        navigate(link.href);
        // After navigation, scroll to section (setTimeout to wait for navigation)
        setTimeout(() => {
          const sectionId = link.href.substring(2); // Remove '/#'
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    }
  };

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.brand}>
            <div className={classes.logo}>
              <span className={classes.logoText}>Arsanyu</span>
            </div>
            <p className={classes.tagline}>
              Building digital excellence, one project at a time.
            </p>
          </div>

          <div className={classes.links}>
            <h4 className={classes.linkTitle}>Quick Links</h4>
            <ul className={classes.linkList}>
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => handleQuickLinkClick(e, link)}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>


        </div>

        <div className={classes.bottom}>
          <p className={classes.copyright}>
            © {currentYear} Arsanyu Technologies. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
